module.exports = __webpack_public_path__ + "static/media/706MeldrumStNW_2018-06-18_111.ea3fe998.jpg";